import React, { memo } from 'react';

const Modal = memo((props) => {
	return (
		<>
			{props.isOpen && (
				<div className="fixed inset-0 flex items-center justify-center z-10">
					<div onClick={props.onClose} className=" modal-overlay fixed inset-0 backdrop-filter backdrop-blur-sm"></div>
					<div className="modal-container bg-white w-full h-full sm:w-screen sm:h-screen md:h-3/5 md:w-3/5 lg:w-2/5 xl:w-1/3 rounded-lg shadow-lg z-20">
						<div className="modal-content p-4 overflow-y-auto h-full">
							<div className="flex justify-end">
								<button onClick={props.onClose} className="text-gray-500">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-6 w-6"
										fill="none"
										viewBox="0 0 24 24"
										stroke="currentColor"
									>
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
									</svg>
								</button>
							</div>
							{props.children}
						</div>
					</div>
				</div>
			)}
		</>
	);
});

export default Modal;
